import Service from "../../services";

const User = {
  namespaced: true,
  state: {
    userCount: "",
    userAdminCount: "",
    certificateCount: "",
    formUser: [],
  },
  mutations: {
    SET_COUNT_USER: (state, val) => {
      state.userCount = val;
    },
    SET_FORM_USER: (state, val) => {
      state.formUser = val;
    },
    SET_COUNT_USER_ADMIN: (state, val) => {
      state.userAdminCount = val;
    },
    SET_COUNT_CERTIFICATE: (state, val) => {
      state.certificateCount = val;
    },
    createState: (state) => {
      state.userCount = "";
      state.certificateCount = "";
    },
  },
  actions: {
    getUserList({ commit }, page) {
      return Service.User.getUserList(page)
        .then((res) => {
          let count = "";
          res.data.forEach((data) => {
            if (!data.researcher_type) {
              count++;
            }
          });
          count = count === 10 ? "10+" : count;
          commit("SET_COUNT_USER", count);
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getAdminList({ commit }, page) {
      return Service.User.getAdminList(page)
        .then((res) => {
          let count = res.unApproveReviewerCount;
          commit("SET_COUNT_USER_ADMIN", count);
          return res.user;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getReviewerList() {
      return Service.User.getReviewerList()
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getUserById({ commit }, id) {
      return Service.User.getUserById(id)
        .then((res) => {
          commit("SET_FORM_USER", res);
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getCertificateList({ commit }, page) {
      return Service.User.getCertificateList(page)
        .then((res) => {
          let count = res.countWaitCertificate;
          commit("SET_COUNT_CERTIFICATE", count);
          return res.user;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    updateCertificate({ commit }, data) {
      return Service.User.updateCertificate(data, data.id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    verifyReviewer({ commit }, data) {
      return Service.User.verifyReviewer(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    updateUser({ commit }, data) {
      return Service.User.updateUser(data, data.id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getResearcherType({ commit }) {
      return Service.User.getResearcherType().then((res) => {
        return res;
      });
    },
    searchAdmin({ commit }, searchData) {
      return Service.User.searchAdmin(searchData)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    searchResearcher({ commit }, searchData) {
      return Service.User.searchResearcher(searchData)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    deleteUser({ commit }, id) {
      return Service.User.deleteUser(id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    createState({ commit }) {
      commit("createState");
    },
    changeUserStatus({ commit }, data) {
      return Service.User.changeUserStatus(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
  },
};

export default User;
